import Notify from "../components/notification/notify";

import DefRoutes from "../routes/routes.json";
import t from "../i18n/i18n";

export function handleApiErrors(errors) {
  const error = errors[0].message || errors[0].type;

  console.log(error);

  if (error === "invalid name") return Notify({ type: "danger", message: t("Errors.InvalidName") });
  if (error === "email_already_in_use") return Notify({ type: "danger", message: t("Errors.EmailAlreadyInUse") });
  if (error === "invalid_change_email_link")
    return Notify({ type: "danger", message: t("Errors.InvalidChangeEmailLink") });
  if (error === "send_sms_error") return Notify({ type: "danger", message: t("Errors.SendSMSError") });
  if (error === "expired_password_token") return window.location.replace(DefRoutes.Logout);
  if (error === "name must be unique") return Notify({ type: "danger", message: t("Errors.NameAlreadyExists") });
  if (error === "email must be unique") return Notify({ type: "danger", message: t("Errors.EmailAlreadyExists") });
  if (error === "invalid_password") return Notify({ type: "danger", message: t("Errors.InvalidLogin") });
  if (error === "invalid_provider_id") return Notify({ type: "danger", message: t("Errors.InvalidProviderId") });
  if (error === "invalid_current_password")
    return Notify({ type: "danger", message: t("Errors.InvalidCurrentPassword") });
  if (error === "can_not_take_reward") return Notify({ type: "danger", message: t("Errors.CanNotTakeReward") });
  if (error === "invalid_token") return Notify({ type: "danger", message: t("Errors.TFAInvalidToken") });
  if (error === "invalid_code") return Notify({ type: "danger", message: t("Errors.TFAInvalidCode") });
  if (error === "invalid_user") return Notify({ type: "danger", message: t("Errors.InvalidUser") });
  if (error === "facebook_id must be unique")
    return Notify({ type: "danger", message: t("Errors.FacebookIdAlreadyExists") });
  if (error === "google_id must be unique")
    return Notify({ type: "danger", message: t("Errors.GoogleIdAlreadyExists") });

  return Notify({ type: "danger", message: t("Errors.Generic") });
}
